import { Colors, FontStyleEnums, Typography } from '@oy/uicore';
import { CSSProperties, HTMLProps, ReactNode, createElement } from 'react';
import { formatString, makeId } from '../../../utilities/idComponent';

type TextProps = {
  children?: string | ReactNode;
  color?: Colors | string;
  isColorInherit?: boolean;
  tag?: 'div' | 'span';
  textStyle: FontStyleEnums;
} & HTMLProps<HTMLDivElement | HTMLSpanElement>;

function getTextStyle(
  isColorInherit: boolean,
  textStyle: FontStyleEnums,
  color?: Colors | string,
): CSSProperties {
  const {
    fontSize = 16,
    fontWeight = 'normal',
    letterSpacing = 0,
    wordWrap = 'break-word',
    fontFamily = 'Inter',
    lineHeight,
  } = Typography[textStyle];

  return {
    color: isColorInherit ? 'inherit' : color,
    fontFamily,
    fontSize,
    fontWeight,
    letterSpacing,
    lineHeight,
    wordWrap,
  };
}

function Text({
  children,
  id,
  textStyle,
  color = Colors.BLACK100,
  isColorInherit = false,
  tag = 'div',
  ...props
}: TextProps) {
  const style: CSSProperties = {
    ...getTextStyle(isColorInherit, textStyle, color),
    ...props.style,
  };

  return createElement(
    tag,
    {
      id: makeId('txt', formatString(children), id),
      ...props,
      style,
    },
    children,
  );
}

Text.Style = FontStyleEnums;

export default Text;
